import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getPerformance, trace} from "firebase/performance";


const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY!,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN!,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID!,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET!,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID!,
  appId: import.meta.env.VITE_FIREBASE_APP_ID!,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID!,
};
// Log the configuration to confirm values are present
// Initialize Firebase with fallbacks
let app;
let analytics = null;
let performance = null;
let trace = () => ({ 
  start: () => {}, 
  stop: () => {}, 
  putMetric: () => {} 
}); // Provide a default no-op implementation

try {
  app = initializeApp(firebaseConfig);
  if (typeof window !== "undefined") {
    analytics = getAnalytics(app);
    performance = getFirebasePerformance(app);
    trace = firebaseTrace;
  }
} catch (error) {
  console.debug("Firebase initialization error:", error);
}

export { app, analytics, performance, trace };
